import React from 'react';
import { ErrorBoundarySuspense } from '../../../index';
var LazyAvatarGroup = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_notification-common/AvatarGroup" */'@atlaskit/avatar-group');
});
export default function AsyncAvatarGroup(props) {
  return /*#__PURE__*/React.createElement(ErrorBoundarySuspense, {
    errorFallback: null,
    loadingFallback: null,
    subjectId: "avatar-group-chunk"
  }, /*#__PURE__*/React.createElement(LazyAvatarGroup, props));
}